// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1249":"8629b2b71c904b90","4155":"46c8d0b70889bca5","6698":"5afed28c9b880cc3","7474":"dcfe41bedce19b24"}[chunkId] + ".js";
};